import React, { useState } from "react";
import { ListItemIcon, ListItemText, Menu, MenuItem } from "@material-ui/core";
import __ from "lodash";

const ContextMenu = props => {
  const [showMenu, setShowMenu] = useState({
    open: false,
    top: 0,
    left: 0
  });

  const handleShowMenu = (e) => {
    e.preventDefault();
    setShowMenu({
      open: !showMenu.open,
      left: e.clientX || 0,
      top: e.clientY || 0,     
    });
  }

  const handleClose = () => {
    setShowMenu({
      open: false,
      left: 0,
      top: 0 ,     
    });
  }

  const handleMenuAction = (item) => {
    handleClose();
    if (item.action) {
      item.action(item.code||item.label);
    } else {
      if (props.onChange) {
        props.onChange(item.code||item.label);
      }
    }
  }

  let menuItems = props.menuItems;
  if (Array.isArray(menuItems)) {
    menuItems = props.menuItems.map((item, i) => {
      const listItemIcon = __.has(item, 'icon')?(
        <ListItemIcon>
          {item.icon}
        </ListItemIcon>
        ):null;
      return (
        <MenuItem key={`context_menu_${i}`} onClick={() => handleMenuAction(item)}>
          {listItemIcon}
          <ListItemText>{item.label}</ListItemText>
        </MenuItem>
      )
    })
  }

  if (menuItems.length < 1) {
    return (
      <div>
        {props.children}
      </div>
    );
  }
  return (
    <div>
      <div onContextMenu={handleShowMenu}>
        {props.children}
      </div>
      <Menu
          open={showMenu.open}
          onClose={handleClose}
          anchorReference="anchorPosition"
          anchorPosition={{ top: showMenu.top, left: showMenu.left }}
        >
          {menuItems}
      </Menu>
    </div>
  )
}

export default ContextMenu;